export enum ESocketSendBinaryType {
  CANARY_AUDIO = 'canary:audio',
}

export interface ISocketSendBinaryMessage {
  type: ESocketSendBinaryType;
  data: ArrayBuffer | Int16Array | Buffer | Blob;
}
